import { Camera } from './camera.model';

export class NIE extends Camera {
}
